import gql from 'graphql-tag';

const CustomerOrderDescription = gql`
  fragment CustomerOrderDescription on CustomerOrderDescription {
    cardType
    customerAddress
    deliveryFee
    deliveryInstructions
    diningDate
    diningTime
    discountInfo
    email
    firstName
    lastName
    orderType
    paymentType
    phoneNumber
    tipAmount
  }
`;

export default CustomerOrderDescription;


// WEBPACK FOOTER //
// ./src/graphql/fragments/order/CustomerOrderDescription.js